/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import isEmpty from 'lodash.isempty';
import {GenericObject} from '@ion/core/src/types/entities';
import CardItemRow from '@ion/dls/src/layout/CardItemRow';
import {
  formatData,
  formatGroundValue,
  getAccumulatorDataLable,
  getAccumulatorDataValue,
  getMssStatus
} from './spreaderUtils';

const MASTER_SWITCH_STATUS = 'mss';

export interface DickeyJohnCardListContentProps {
  measures: GenericObject;
  translations: string | GenericObject;
}

const DickeyJohnCardListContent = ({
  measures,
  translations
}: DickeyJohnCardListContentProps) => {
  const {
    flowRate,
    ...accumulatorData
  } = measures;
  if (flowRate || accumulatorData) {
    return (
      <>
        {flowRate?.map((data: {[key: string]: any}, index: number) => {
          if (Object.keys(data).length === 1) {
            const key = Object.keys(data)[0];
            const value = Object.values(data)[0];
            return (
              <CardItemRow key={`${index}-${key}`}
                label={translations?.[key]}
                value={key === MASTER_SWITCH_STATUS
                  ? getMssStatus(value?.trim())
                  : formatGroundValue(data)}
                isCenterAligned={false}
                isBottomMargin={false}
                isTextRightAligned
                isCondensedVariant />
            );
          } else {
            const key = data?.channel.split('_').join('').toLowerCase();
            return (
              <CardItemRow key={`${index}-${data.value}`}
                label={translations?.[`${key}${data?.type}`]}
                value={formatData(data)}
                isCenterAligned={false}
                isBottomMargin={false}
                isTextRightAligned
                isCondensedVariant />
            );
          }
        })}
        {!isEmpty(accumulatorData) && Object.entries(accumulatorData).map(([_key, settings]) => {
          return Object.entries(settings).map(([_setting, data]) => {
            return (data as any)?.map(datum => {
              const {type, value, units, setting} = datum || {};
              return (
                <CardItemRow key={`${type}-${units}`}
                  label={getAccumulatorDataLable(setting, type, units)}
                  value={getAccumulatorDataValue(setting, value, units)}
                  isCenterAligned={false}
                  isBottomMargin={false}
                  isTextRightAligned
                  isCondensedVariant />
              );
            });
          });
        })
        }
      </>
    );
  }
  return null;
};

export default DickeyJohnCardListContent;
